import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=658815d6&scoped=true&"
import script from "./MainSlide.vue?vue&type=script&lang=js&"
export * from "./MainSlide.vue?vue&type=script&lang=js&"
import style0 from "./MainSlide.vue?vue&type=style&index=0&id=658815d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658815d6",
  null
  
)

export default component.exports